import { render, staticRenderFns } from "./TypeEdit.vue?vue&type=template&id=828e3914"
import script from "./TypeEdit.vue?vue&type=script&lang=js"
export * from "./TypeEdit.vue?vue&type=script&lang=js"
import style0 from "./TypeEdit.vue?vue&type=style&index=0&id=828e3914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports